<template>
    <flex-element
        :element-type="elementType"
        class="f-break-words f-whitespace-pre-line"
        :tag="renderTag"
        @blur="onInput"
    >
        <!-- need to keep renderTextPreview and surrounding HTML tags on the same line because of white-space:pre-line -->
        <span v-if="previewMode">{{ renderTextPreview }}</span>

        <span
            v-else
            v-text-select="multiLineTextNew"
            :contenteditable="isContentEditable"
            @input="setChangedData(true)"
            @blur="onInput"
            @paste="onPaste"
        />
    </flex-element>
</template>

<script>
import baseAtom from '@/mixins/base-atom/base-atom-smart';
import { ATextMultiLine } from '@/data/data-models';

const MAX_CHARS_ATTR = 'max-characters';
const PLACEHOLDER_TEXT = '[Text here]';

export default {
    name: 'a-text-multi-line',
    mixins: [baseAtom],

    props: {
        displayName: {
            type: String,
            default: 'Multi-line Text',
        },

        multiLineText: {
            type: String,
            default: '',
        },

        tag: {
            type: String,
            default: '',
        },

        tagDefault: {
            type: String,
            default: 'p',
        },

        templateId: {
            type: String,
            default: '{0DFCBBFA-AF77-4D0C-A6D6-A83BA7900DFB}',
        },
    },

    data() {
        return {
            cssDisplay: 'block',
            multiLineTextNew: '',
            tagNew: '',
        };
    },

    computed: {
        renderTextPreview() {
            if (this.multiLineTextNew === PLACEHOLDER_TEXT) {
                return '';
            }
            return this.multiLineTextNew;
        },

        renderTag() {
            return this.tagNew || this.tagDefault;
        },

        updatedElement() {
            return new ATextMultiLine({
                ...this.updatedBaseElement,
                multiLineText: this.multiLineTextNew === PLACEHOLDER_TEXT ? '' : this.multiLineTextNew,
                tag: this.renderTag,
            });
        },
    },

    methods: {
        setFieldValues() {
            const maxCharLimit = this.getElementData(MAX_CHARS_ATTR);
            let multiLineTextNew = this.multiLineText || (this.$slots.default ? this.$slots.default[0].text.trim() : PLACEHOLDER_TEXT);

            if (maxCharLimit) {
                multiLineTextNew = `${ multiLineTextNew.slice(0, maxCharLimit) }...`;
            }

            this.multiLineTextNew = multiLineTextNew;
            this.tagNew = this.tag;
        },

        onInput(e) {
            this.multiLineTextNew = e.target.innerText;
        },

        onPaste(evt) {
            let text = '';
            evt.preventDefault();
            if (evt.clipboardData || evt.originalEvent.clipboardData) {
                text = (evt.originalEvent || evt).clipboardData.getData('text/plain');
            } else if (window.clipboardData) {
                text = window.clipboardData.getData('Text');
            }
            if (document.queryCommandSupported('insertText')) {
                document.execCommand('insertText', false, text);
            } else {
                document.execCommand('paste', false, text);
            }
        },
    },
};
</script>
